/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { ProductMappingDto } from '../../models/product-mapping-dto';
import { ProductMappingResponse } from '../../models/product-mapping-response';

export interface UpdateProductMapping$Params {
  productMappingId: string;
      body: ProductMappingDto
}

export function updateProductMapping(http: HttpClient, rootUrl: string, params: UpdateProductMapping$Params, context?: HttpContext): Observable<StrictHttpResponse<ProductMappingResponse>> {
  const rb = new RequestBuilder(rootUrl, updateProductMapping.PATH, 'put');
  if (params) {
    rb.path('productMappingId', params.productMappingId, {});
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/hal+json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<ProductMappingResponse>;
    })
  );
}

updateProductMapping.PATH = '/product-mapping/{productMappingId}';
